import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const appTitleSlice = createSlice({
  name: 'appTitle',
  initialState: '',
  reducers: {
    updateAppTitle: (_state, action: PayloadAction<string>) => {
      return action.payload
    },
  },
})

export const { updateAppTitle } = appTitleSlice.actions
export default appTitleSlice.reducer
